import { __awaiter, __generator } from "tslib";
export function loadDealfront(analytics) {
    return __awaiter(this, void 0, void 0, function () {
        var reveal;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window.discover) {
                        return [2 /*return*/];
                    }
                    if (!window.discover || window.discover.meta.status !== 200) {
                        return [2 /*return*/];
                    }
                    reveal = window.discover.data.company;
                    return [4 /*yield*/, analytics.group(null, {
                            website: reveal.domain,
                            intentSource: 'dealfront',
                            name: reveal.name || undefined,
                            industry: reveal.industries.name || undefined,
                            number_of_employees: reveal.employees_category || undefined,
                            annual_revenue: reveal.revenue.amount || undefined,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=dealfront.js.map